/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonApiLogInfo,
    JsonApiLogInfoFromJSON,
    JsonApiLogInfoFromJSONTyped,
    JsonApiLogInfoToJSON,
} from './JsonApiLogInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonApiLogInfo
 */
export interface ApiResultOfListOfJsonApiLogInfo {
    /**
     * 
     * @type {Array<JsonApiLogInfo>}
     * @memberof ApiResultOfListOfJsonApiLogInfo
     */
    data?: Array<JsonApiLogInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonApiLogInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonApiLogInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonApiLogInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonApiLogInfo
     */
    result?: ApiResultOfListOfJsonApiLogInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonApiLogInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonApiLogInfoFromJSON(json: any): ApiResultOfListOfJsonApiLogInfo {
    return ApiResultOfListOfJsonApiLogInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonApiLogInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonApiLogInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonApiLogInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonApiLogInfoToJSON(value?: ApiResultOfListOfJsonApiLogInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonApiLogInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

